
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/courses/gh201u",
      function () {
        return require("private-next-pages/actuary/courses/gh201u/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/courses/gh201u"])
      });
    }
  